export default "__VITE_ASSET__f05822a7__"